import PaystubWizard from "../components/PaystubWizard";
import { useNavigate } from "react-router-dom";
import MobileNav from "../components/MobileNav";

export default function PaystubWizardPage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-zinc-950">
      <MobileNav />
      <PaystubWizard onExit={() => navigate("/")} />
    </div>
  );
}
